import { table } from './_table';

export const stats = {
  namespaced: true,
  modules: {
    table
  }
};
